import React from 'react';
import {Nav} from 'react-bootstrap';
import { Link } from 'react-router-dom';

function Permissions() {
    return (
        <div>
            <h1 className='page-title'>Admin Settings</h1>
            <Nav
                className='setting-menu'
            >
                <Nav.Item>
                    <Link to="/admin-settings/modules" className='nav-link'>Modules</Link>
                </Nav.Item>
                <Nav.Item>
                    <Link to="/admin-settings/permissions" className='nav-link active'>Permissions</Link>
                </Nav.Item>
                <Nav.Item>
                    <Link to="/admin-settings/roles" className='nav-link'>Roles</Link>
                </Nav.Item>
            </Nav>

            <div className='profile-sec'>
                <h4>Permissions</h4>
            </div>
        </div>
    )
}

export default Permissions